import { FilterQuery } from '@yes.technology/react-toolkit'
import { merge } from 'lodash'
import { useMemo } from 'react'

type UseMergedFilterQueryProps = {
  filterQuery?: FilterQuery
  manifestFilterQuery?: FilterQuery
}

const useMergedFilterQuery = ({
  filterQuery,
  manifestFilterQuery
}: UseMergedFilterQueryProps): FilterQuery | undefined => {
  // TODO: manifestFilterQuery should be a dependency of the useMemo, but it is not memoized, leading to unnecessary re-renders
  const mergedFilterQuery = useMemo(() => {
    if (filterQuery || manifestFilterQuery) {
      return { ...merge(filterQuery, manifestFilterQuery) }
    }
    return filterQuery
  }, [filterQuery])

  return mergedFilterQuery
}

export default useMergedFilterQuery
